import { HAS_END_CUSTOMER } from "../utils/constants";
import { type ConfiguredQuickEntryItem, type QuickEntryItem, type QuickEntryItemPC } from "./models";
import { userCanSeeEndCustomer, userCanSeePriceReference } from "../Cart/components/CartPage/LineItemStaticParams";

export const canSeePriceRefColumn = () => userCanSeePriceReference() && !HAS_END_CUSTOMER;

export const canSeeStaticPriceRefColumn = userCanSeeEndCustomer;

export const noPriceReference = () => window.SCHA.config.priceReferences.length <= 1;

export const hasProductConfigured = (item: QuickEntryItem): item is ConfiguredQuickEntryItem => !!item.product;
export const hasProductConfiguredPC = (item: QuickEntryItemPC): item is ConfiguredQuickEntryItem => !!item.product;
